import { getApi } from "./api_instance";

export const getWalletBalance = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: `/payments/api/wallet/balance`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
